(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('NovaTarefaChamadoController', NovaTarefaChamadoController);

    NovaTarefaChamadoController.$inject = ['chamado', 'SolicitacaoDesenvolvimento', '$state', 'Alerta'];

    function NovaTarefaChamadoController(chamado, SolicitacaoDesenvolvimento, $state, Alerta) {
        var vm = this;
        vm.chamado = chamado;
        vm.tiposTarefa = ['BUG', 'HISTORIA', 'SCRUM', 'REUNIAO', 'SPIKE'];
        vm.isSaving = false;

        vm.solicitacaoDesenvolvimento = {
            chamado: {id: chamado.id},
            titulo: tituloPadrao(),
            tipo: tipoPadrao(),
            tempoEstimado: chamado.tempoEstimado || 1,
            conteudo: chamado.conteudo,
            criterio: chamado.criterio
        };

        vm.salvar = salvar;
        vm.cancelar = cancelar;

        function tituloPadrao() {
            var base = chamado.titulo || ('Chamado #' + chamado.id);
            var qtd = chamado.solicitacoesDesenvolvimento ? chamado.solicitacoesDesenvolvimento.length : 0;
            if (qtd > 0) {
                return base + ' — tarefa ' + (qtd + 1);
            }
            return base;
        }

        function tipoPadrao() {
            var map = {
                BUG: 'BUG',
                MELHORIA: 'HISTORIA',
                NOVA_FUNCIONALIDADE: 'HISTORIA',
                SUPORTE: 'SPIKE',
                ATA: 'REUNIAO'
            };
            return map[chamado.tipoChamado] || 'HISTORIA';
        }

        function salvar() {
            if (!vm.solicitacaoDesenvolvimento.titulo || !vm.solicitacaoDesenvolvimento.tipo) {
                Alerta.warn('Atenção', 'Preencha título e tipo da tarefa.');
                return;
            }
            if (!vm.solicitacaoDesenvolvimento.tempoEstimado || vm.solicitacaoDesenvolvimento.tempoEstimado <= 0) {
                Alerta.warn('Atenção', 'Informe o tempo estimado em horas.');
                return;
            }
            vm.isSaving = true;
            vm.solicitacaoDesenvolvimento.chamado = {id: chamado.id};
            vm.solicitacaoDesenvolvimento.conteudo = chamado.conteudo;
            vm.solicitacaoDesenvolvimento.criterio = chamado.criterio;

            SolicitacaoDesenvolvimento.save(vm.solicitacaoDesenvolvimento, function (result) {
                vm.isSaving = false;
                Alerta.success('Operação realizada', 'Tarefa #' + result.numero + ' criada.');
                $state.go('edit-chamado', {id: chamado.id}, {reload: true});
            }, function () {
                vm.isSaving = false;
                Alerta.error('Operação não realizada', 'Não foi possível criar a tarefa. Verifique permissões e situação do chamado.');
            });
        }

        function cancelar() {
            $state.go('edit-chamado', {id: chamado.id});
        }
    }
})();
